import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import ReactDOM from 'react-dom';
import { MenuItem, Button, Overlay } from 'react-bootstrap';

import styles from './styles.css';

function InnerPopover({ children, className, style }) {
  return (
    <div className={`${styles.menuPopover} ${className}`} style={style}>
      {children}
    </div>
  );
}
InnerPopover.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};
InnerPopover.defaultProps = {
  className: null,
  children: null,
  style: {},
};

class ActionRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      confirmed: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.getTarget = this.getTarget.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.requestEdit = this.requestEdit.bind(this);
    this.handleMenuAction = this.handleMenuAction.bind(this);
  }

  getTarget() {
    return ReactDOM.findDOMNode(this.target);
  }

  handleToggle() {
    this.setState({ open: !this.state.open, confirmed: false });
  }

  requestDelete() {
    if (!this.state.confirmed) {
      this.setState({ confirmed: true });
    } else {
      this.setState({ confirmed: false, open: false }, () => {
        this.props.requestDelete(this.props.data);
      });
    }
  }

  handleMenuAction(menu) {
    this.props.handleMenuAction(menu, this.props.data);
    this.handleToggle();
  }

  requestEdit() {
    this.props.requestEdit(this.props.data);
  }

  renderInner() {
    const {
      canEdit, updating, deleting,
      canDelete, menu, header,
    } = this.props;
    const { confirmed } = this.state;
    const disabled = updating || deleting;

    return (
      <div className="clearfix open">
        <ul className="dropdown-menu">
          {header !== null && <MenuItem header>{header}</MenuItem>}
          {canEdit && <MenuItem disabled={disabled} onClick={this.requestEdit}><Fa name="edit" /> Edit</MenuItem>}
          {menu.map(m => (<MenuItem key={m.id} eventKey={m} disabled={disabled} onClick={() => { this.handleMenuAction(m); }}>{m.label}</MenuItem>))}
          {canDelete &&
            <MenuItem disabled={disabled} onClick={this.requestDelete}>
              {confirmed && <span className="text-danger"><Fa name="trash" /> Are you sure?</span>}
              {!confirmed &&
                <span>
                  {!deleting && <span><Fa name="trash" /> Delete</span>}
                  {deleting && <span><Fa name="spinner" spin /> Deleting</span>}
                </span>
              }
            </MenuItem>
          }
        </ul>
      </div>
    );
  }

  render() {
    const { deleting, updating, data } = this.props;
    const disabled = deleting || updating;
    const { open } = this.state;
    const org = data;
    const syncing = org && org.syncing === true;

    const label = syncing ? 'Syncing' : 'Actions';

    return (
      <div style={{ position: 'relative' }}>
        <Button
          disabled={disabled}
          ref={(target) => {
            this.target = target;
          }}
          bsStyle="primary"
          bsSize="xs"
          onClick={this.handleToggle}
        >
          {label} <Fa name={syncing ? 'spinner' : 'caret-down'} spin={syncing} />
        </Button>
        <Overlay
          show={open}
          rootClose
          onHide={() => this.setState({ open: false })}
          placement="bottom"
          target={this.getTarget}
        >
          <InnerPopover>
            {this.renderInner()}
          </InnerPopover>
        </Overlay>
      </div>
    );
  }
}

ActionRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    name: PropTypes.string,
    is_demo: PropTypes.bool,
    tru_voice_clients: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  header: PropTypes.node,
  deleting: PropTypes.bool,
  updating: PropTypes.bool,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  requestEdit: PropTypes.func,
  requestDelete: PropTypes.func,
  handleMenuAction: PropTypes.func,
  menu: PropTypes.arrayOf(PropTypes.shape({})),
};
ActionRenderer.defaultProps = {
  header: null,
  data: null,
  deleting: false,
  updating: false,
  canEdit: false,
  canDelete: false,
  requestEdit: () => {},
  requestDelete: () => {},
  handleMenuAction: () => {},
  menu: [],
};

export default ActionRenderer;
